
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'yesNo' })
export class YesNoPipe implements PipeTransform {
    transform(value: any) {
        return value == 1 ? 'Yes' : 'No';
    }
}

@Pipe({ name: 'statusBadge' })
export class StatusBadge implements PipeTransform {
    transform(value: any) {
        switch (value) {
            case "Active": return 'success'; break;
            case "Paid": return 'success'; break;
            case "Resolved": return 'success'; break;
            case "New": return 'success'; break;
            case "InProgress": return 'warning'; break;
            case "Deleted": return 'danger'; break;
            case "InActive": return 'dark'; break;
            case "Disabled": return 'dark'; break;
            case "UnPaid": return 'danger'; break;
            case "In": return 'danger'; break;
            case "Out": return 'dark'; break;
            case "PreAuthorized": return 'warning'; break;
            case "Completed": return 'dark'; break;
            case "Created": return 'warning'; break;
            case "Cancelled": return 'danger'; break;
            case "Occupied": return 'dark'; break;
            case "Available": return 'success'; break;
            case "PendingVerification": return 'warning'; break;
            case "Verified": return 'success'; break;
            case "Restricted": return 'danger'; break;
            case "Rejected": return 'danger'; break;
            default: return value;
        }

    }
}
